import { RootState } from '../../store';

export function selectCurrentUser(state: RootState) {
  return state.auth?.user;
}

export function selectSwitchedUsername(state: RootState) {
  return state.auth?.actingAs;
}
